var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUserAdd24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-5.5-3a.5.5 0 01.5.5v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-1 0v-2h-2a.5.5 0 010-1h2V7a.5.5 0 01.5-.5zM3.64 8.14a2.84 2.84 0 115.68 0 2.84 2.84 0 01-5.68 0zM6.48 6.3a1.84 1.84 0 100 3.68 1.84 1.84 0 000-3.68zm0 6.02A5.18 5.18 0 001.3 17.5c0 .595.258 1.151.437 1.473.223.399.64.587 1.036.587h7.413c.395 0 .812-.187 1.035-.585.18-.322.439-.879.439-1.475a5.18 5.18 0 00-5.18-5.18zM2.3 17.5a4.18 4.18 0 118.36 0c0 .335-.156.709-.312.986-.017.031-.066.074-.162.074H2.773c-.096 0-.145-.043-.162-.074-.155-.278-.311-.651-.311-.986z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAdd24);
export default __webpack_public_path__ + "static/media/icon-user-add-24.300e1721.svg";
export { ForwardRef as ReactComponent };